import { today } from "@internationalized/date";

// Locales we support
export const SUPPORTED_LOCALES = [
  "en",
  "ja",
  "ko",
  "th",
  "zh-CN",
  "zh-TW",
] as const;

export type SiteLocale = (typeof SUPPORTED_LOCALES)[number];

// Currencies buyers can get estimates for
export const SUPPORTED_CURRENCIES = [
  "usd",
  "eur",
  "cny",
  "krw",
  "twd",
  "gbp",
  "aud",
  "cad",
  "nzd",
] as const;

// Settle everything between Bókun and Stripe in JPY
export const SETTLEMENT_CURRENCY = "jpy";

export type SiteCurrency = (typeof SUPPORTED_CURRENCIES)[number];

export const TIMEZONE = "Asia/Tokyo";

export function getTripMinCalendarDate() {
  return today(TIMEZONE).add({ days: 7 });
}

export const ROOM_TIERS = ["comfort", "luxury"] as const;
export type RoomTier = (typeof ROOM_TIERS)[number];

export const ROOM_TIER_LEVELS = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
] as const;
export type RoomTierLevel = (typeof ROOM_TIER_LEVELS)[number];

export const ROOM_UPGRADES = ["breakfast", "half-board"] as const;
export type RoomUpgrade = (typeof ROOM_UPGRADES)[number];

export interface SearchPassengers {
  adults: number;
  children: { age: number }[];
}

export type CurrencyCode = (typeof SUPPORTED_CURRENCIES)[number] | "jpy";

// Contact information
export const CONTACT_PHONE = "+81 03-4578-2152";
export const CONTACT_EMAIL = "info@triptojapan.com";
